module.exports = __webpack_public_path__ + "img/blog2.56bfb871.png";